import { render, staticRenderFns } from "./CoreAssignModal.html?vue&type=template&id=01d15a1d&external"
import script from "./CoreAssignModal.vue?vue&type=script&lang=js"
export * from "./CoreAssignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports